import { render, staticRenderFns } from "./InviteAndEarnBannerDesktop.vue?vue&type=template&id=1606c4a2&scoped=true"
import script from "./InviteAndEarnBannerDesktop.vue?vue&type=script&lang=js"
export * from "./InviteAndEarnBannerDesktop.vue?vue&type=script&lang=js"
import style0 from "./InviteAndEarnBannerDesktop.vue?vue&type=style&index=0&id=1606c4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606c4a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
